<template>
  <div class="login flex-center">
    <v-card class="modal modal-round">

      <div class="logo-wrapper flex-center">
        <img src="/images/logo.svg"
             alt="wifeed-logo"
             class="logo">
      </div>

      <form class="form"
            @submit="preventDefault">

        <v-text-field v-model="password"
                      label="NOVA SENHA"
                      type="password"
                      class="font-lg"></v-text-field>

        <v-text-field v-model="passwordRepeat"
                      label="CONFIRME SUA SENHA"
                      type="password"
                      class="font-lg"></v-text-field>

        <button class="btn btn-primary btn-extra-round"
                @click="submit"
                @submit="preventDefault">
          Salvar
        </button>

      </form>
    </v-card>

    <vue-recaptcha @verify="onVerifyCaptcha"
                   ref="recaptcha"
                   size="invisible"
                   :loadRecaptchaScript="true"
                   sitekey="6LfD48YUAAAAAPJ2LiZ86AloaAMg5Yq9ZZQyo69-">
    </vue-recaptcha>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import EventBus from "@packages/event-bus";

export default {
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      password: null,
      passwordRepeat: null,
      hash: "",
      email: "",
    };
  },

  computed: {
    user() {
      return this.$store.state.users.user;
    },

    admin() {
      return this.$store.state.users.admin;
    },
  },

  created() {
    this.checkHash();
  },

  methods: {
    onVerifyCaptcha: function (response) {
      this.submitLogin(response);
    },
    preventDefault(evt) {
      evt.preventDefault();
    },
    async submitLogin(keycaptcha) {
      const loginUser = await this.$auth.login({
        username: this.email,
        password: this.password,
        captcha: keycaptcha,
      });

      if (loginUser) {
        this.$store.commit("SET_USER", {
          accountId: loginUser.accountId,
          id: loginUser.id,
          login: loginUser.login,
          nome: loginUser.userName,
          permissions: loginUser.permissions,
          tipo: loginUser.accountType,
        });

        const isPartner = loginUser.accountType === "PARCEIRO" ? true : false;
        this.$store.commit("SET_PARCEIRO", isPartner);

        if (isPartner) {
          this.$router.push("/estabelecimentos");
        } else {
          this.$router.push("/visao-geral");
        }
      }

      if (this.admin) {
        this.$router.push("/admin/estabelecimentos");
      }
    },
    async submit() {
      if (!this.password || !this.passwordRepeat) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: "Informe a senha e a confirmação",
        });
        return;
      }
      if (this.password != this.passwordRepeat) {
        EventBus.$emit("show-message", {
          type: "ERROR",
          message: "Senhas não conferem",
        });
        return;
      }
      let response = await this.$api.accountRecovery.recoverPassword({
        hash: this.hash,
        password: this.password,
      });

      this.email = response;

      this.$refs.recaptcha.execute();

      EventBus.$emit("show-message", {
        type: "SUCCESS",
        message: "Senha redefinida com sucesso!",
        timeout: 3000,
      });
      //window.location.href = '/login'
    },
    async checkHash() {
      try {
        this.hash = this.$route.query.hash;

        const res = await this.$api.accountRecovery.checkHash({
          hash: this.$route.query.hash,
        });
        const isBoolean = typeof res === "boolean";

        const isValid = isBoolean ? res : res.data;

        if (!isValid) {
          EventBus.$emit("show-message", {
            type: "ERROR",
            message: "Esta operação não está mais disponivel",
          });
          setTimeout(() => {
            window.location.href = "/login";
          }, 200);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.login {
  width: 100vw;
  height: 100vh;
  background: $primary;

  .modal {
    min-width: 500px;
    padding: 42px;

    .logo-wrapper {
      width: 100%;
      margin-bottom: 42px;

      .logo {
        max-width: 197px;
        height: auto;
      }
    }

    .form {
      text-align: center;

      & > *:not(:last-child) {
        margin-bottom: 22px !important;
      }

      .btn {
        font-size: 18px;
        text-transform: uppercase;
        padding: 8px 42px;
      }
    }
  }

  .forgot-password {
    cursor: pointer;
  }
}
</style>
